import { Form, InputNumber } from '@arco-design/web-react'
import SettingSectionCard from '../SettingSectionCard'
import InstantSwitch from '../InstantSwitch'
import type { OptionsAPI } from '../useOptions'

const KEYS = ['LogConsumeEnabled', 'log_setting.max_range_days', 'log_setting.user_export_enabled']

export default function LogSection({ options }: { options: OptionsAPI }) {
  const { getNumber, getBool, patch } = options
  return (
    <SettingSectionCard
      title="日志设置"
      subtitle="是否记录消费日志、用户能查多久、能否自己导出"
      keys={KEYS}
      options={options}
    >
      <Form layout="vertical">
        <div className="grid md:grid-cols-3 gap-3">
          <Form.Item label="记录消耗日志">
            <InstantSwitch options={options} optionKey="LogConsumeEnabled" defaultChecked />
          </Form.Item>
          <Form.Item
            label="用户最长查询跨度（天）"
            extra="超出范围后端会拒绝查询；管理员导出同样受限"
          >
            <InputNumber
              style={{ width: '100%' }}
              min={1}
              value={getNumber('log_setting.max_range_days', 30)}
              onChange={(v) => patch({ 'log_setting.max_range_days': v ?? 30 })}
            />
          </Form.Item>
          <Form.Item label="允许用户导出自己的日志">
            <InstantSwitch
              options={options}
              optionKey="log_setting.user_export_enabled"
              defaultChecked={getBool('log_setting.user_export_enabled', true)}
            />
          </Form.Item>
        </div>
      </Form>
    </SettingSectionCard>
  )
}
